import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { map, take } from 'rxjs';



@Injectable()
export class UserRoleAuthGuard implements CanActivate {

  constructor(private auth: AngularFireAuth, private router: Router, public snackBar: MatSnackBar) {}

/* canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.auth.getUser()?.pipe(
      map(user => !!user),
      tap(authenticated => {
        authenticated || this.router.parseUrl('auth/login')
      })
    )
    }*/
    canActivate() {
      return this.auth.authState.pipe(
        take(1),
        map(user => {
          if (user) {
            return true;
          } else {
            this.router.navigate(['/auth/login']);
            return false;
          }
        })
      );
    }
}
